import { useState } from 'react';
import RModal from '../../../../../components/Rsuite/Modal';
import { CustomInput } from '../../../../../components/CustomInput';
import { Label } from '../../../../../components/Label';

import * as S from './styles';
import { Spacer } from '../../../../../components/Spacer';
import { CustomCheckPicker } from '../../../../../components/CustomCheckPicker';
import { CustomButton } from '../../../../../components/CustomButton';
import api from '../../../../../services/api';
import { toastSuccess, toastError } from '../../../../../toasts';
import { daysLabels } from '../../../../../constants/daysLabels';
import { dataDays } from '../../../../../constants/dataDays';
import { useEffect } from 'react';

export const EditShedule = ({
  open,
  handleClose,
  schedule,
  getSchedules,
  groupId,
  companyId,
}) => {
  const [selecteds, setSelecteds] = useState([]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  const isEdit = !!schedule?.Id;

  const validateFields = () => {
    if (!isEdit && (!Array.isArray(selecteds) || selecteds.length < 1)) {
      throw new Error('Selecione dias para criar horários');
    }

    if (typeof start !== 'string' || start.length < 5) {
      throw new Error('Selecione a hora de início');
    }

    if (typeof start !== 'string' || end.length < 5) {
      throw new Error('Selecione a hora de termino');
    }
  };

  const validateInfo = () => {
    if (!companyId || !groupId) {
      throw new Error();
    }
  };

  const handleSubmit = async () => {
    if (isEdit) {
      editSchedule();
      return;
    }
    createSchedules();
  };

  const createSchedules = async () => {
    try {
      validateFields();
      validateInfo();

      const horarios = selecteds.map((day) => ({
        IdEmpresa: companyId,
        GroupId: groupId,
        Day: day,
        Start: start,
        End: end,
      }));

      await api.post(`horarios-grupo/criar-muitos`, {
        horarios,
      });

      getSchedules();

      toastSuccess('Horários foram salvos');
      handleClose();
    } catch (error) {
      const errorMessage = error?.message || 'Não foi possivel criar horários';
      toastError(errorMessage);
    }
  };

  const editSchedule = async () => {
    try {
      validateFields();
      validateInfo();

      const _schedule = {
        Start: start,
        End: end,
      };

      await api.patch(`horarios-grupo/${schedule.Id}`, _schedule);

      getSchedules();

      toastSuccess('Horário foi salvo');
      handleClose();
    } catch (error) {
      const errorMessage = error?.message || 'Não foi possivel edirar horário';
      toastError(errorMessage);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setStart(schedule?.Start);
      setEnd(schedule?.End);
    }
  }, [schedule]);

  return (
    <RModal
      open={open}
      onClose={handleClose}
      title="Editar Horário"
      footer={
        <>
          <CustomButton appearance="default" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
        </>
      }
    >
      {!isEdit && (
        <S.Column>
          <Label>Dia(s)</Label>
          <CustomCheckPicker
            data={dataDays}
            searchable={false}
            onChange={setSelecteds}
            style={{ width: 350 }}
          />
        </S.Column>
      )}

      {isEdit && (
        <S.Column>
          <S.Title>{daysLabels[schedule.Day]}</S.Title>
        </S.Column>
      )}

      <Spacer y={10} />
      <S.Row>
        <S.Column>
          <Label>Início</Label>
          <CustomInput
            type="time"
            onChange={setStart}
            defaultValue={schedule?.Start}
          />
        </S.Column>
        <S.Column>
          <Label>Fim</Label>
          <CustomInput
            type="time"
            onChange={setEnd}
            defaultValue={schedule?.End}
          />
        </S.Column>
      </S.Row>
      <Spacer y={20} />
    </RModal>
  );
};
